import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { appTheme } from './themes/themes';
import Home from './pages/Home';
import Root from './pages/Root';
import ErrorPage from './pages/ErrorPage';
import Search from './pages/Search';
import { AppProvider } from './contexts/AppContext';
import Account from './pages/Account';
import NewPlan from './pages/NewPlan';
import Auth from './pages/Auth';
import AddRace from './pages/AddRace';
import Planner from './pages/Planner';
import LangWrapper from './contexts/LangWrapper';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Checkout from './pages/Checkout';
import Payment from './pages/Payment';
import Insta from './pages/Insta';
import Help from './pages/Help';
import Export from './pages/Export';
import CssBaseline from '@mui/material/CssBaseline';
import { PostHogProvider } from 'posthog-js/react';
import FeatureRequests from './pages/FeatureRequests';
import CompareActivity from './pages/CompareActivity';
import EditPlanCPs from './pages/EditPlanCPs';
import Races from './pages/Races';
import PaymentLifetime from './pages/PaymentLifetime';
import SubscriptionManagement from './pages/SubscriptionManagement';
import NutritionalTraining from './pages/NutritionalTraining';
import AddTrainingRun from './pages/AddTrainingRun';
import EditTrainingRun from './pages/EditTrainingRun';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppProvider>
      <LangWrapper>
        <Root />
      </LangWrapper>
    </AppProvider>,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "plans", element: <Home />,
      },
      { path: "plans/new", element: <NewPlan /> },
      { path: "plans/:userId/:planId", element: <Planner /> },
      { path: "_external/:userId/:planId", element: <Insta /> },
      {
        path: "export/:userId/:planId",
        element: <Export />,
      },
      {
        path: "races",
        element: <Races />,
      },
      {
        path: "nutritional-training",
        element: <NutritionalTraining />,
      },
      {
        path: "nutritional-training/add",
        element: <AddTrainingRun />,
      },
      {
        path: "nutritional-training/edit/:id",
        element: <EditTrainingRun />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "account",
        element: <Account />,
      },
      {
        path: "subscription",
        element: <SubscriptionManagement />,
      },
      {
        path: "checkout",
        element: <Checkout />,
      },
      {
        path: "payment",
        element: <Payment />,
      },
      {
        path: "payment-lifetime",
        element: <PaymentLifetime />,
      },
      {
        path: "sign-in",
        element: <Auth />,  
      },
      {
        path: "sign-up",
        element: <Auth />,
      },
      {
        path: "forgot-password",
        element: <Auth />,
      },
      {
        path: "add-race",
        element: <AddRace />,
      },
      {
        path: "help",
        element: <Help />,
      },
      {
        path: "feature-requests",
        element: <FeatureRequests />,
      },
      {
        path: "compare/:userId/:planId",
        element: <CompareActivity />,
      },
      {
        path: "edit/:userId/:planId",
        element: <EditPlanCPs />,
      }
    ],
  },
]);

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY || ""}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        debug: process.env.NODE_ENV === "development",
      }}
    >
      <ThemeProvider theme={appTheme}>
        <CssBaseline enableColorScheme />
        <RouterProvider router={router} />
      </ThemeProvider>
    </PostHogProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
